// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_a456f699","mobileHeader":"_8f8e6b95"};